// src/services/visitService

import { apiCall } from '../../utils/restclient'
import { getVisitInfoPromiseAction, setVisitError } from '../../store/visits/VisitsActions'
import { getUserFriendlyErrorMessage, errorCodes } from '../../utils/errormessages'
/**
 * Fetches visit, provider, and patient information.
 *
 * @param {string} visitId - The ID of the visit to fetch.
 * @param {function} dispatch - The Redux dispatch function.
 * @returns {Promise<Object>} - A promise that resolves to the combined visit details.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitInfoPromise = async (visitId, dispatch) => {
  const visitEndpoint = `api/v1/visits/${visitId}`
  dispatch(getVisitInfoPromiseAction())

  try {
    const visitData = await apiCall(visitEndpoint, 'GET', null, null, null)

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isCoveredByPackage = visitData.Coverage != null
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    if (!visitData.IsVisitTypeAvailable || (visitData.IsPriceChanged && !isCoveredByPackage)) {
      dispatch(setVisitError(getUserFriendlyErrorMessage(errorCodes.CANNOT_RESHEDULE_VISIT)))
      return
    }

    // Extract providerId and patientId from visitData
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const providerId = visitData.Provider?.ProviderId || visitData.DoctorId
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const patientId = visitData.PatientId || visitData.Patient?.PatientId

    // Define endpoints for provider and patient
    const providerEndpoint = `/api/v1/providers/${providerId}`
    const patientEndpoint = `/api/v1/patients/${patientId}`

    // Fetch provider and patient info in parallel
    const [providerData, patientData] = await Promise.all([
      apiCall(providerEndpoint, 'GET', null, null, null),
      apiCall(patientEndpoint, 'GET', null, null, null),
    ])

    // Combine visitData with providerData and patientData
    const combinedData = {
      // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
      ...visitData,
      Provider: providerData,
      Patient: patientData,
    }

    console.log('Combined visitDetailsInfo:', combinedData)

    return combinedData
  } catch (error) {
    console.error('Error fetching visit, provider, or patient info:', error)
    throw error // Re-throw the error to be handled by the caller
  }
}
